var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_584_928)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 10.5C24 10.1022 23.842 9.72064 23.5607 9.43934C23.2794 9.15804 22.8978 9 22.5 9C22.1022 9 21.7206 9.15804 21.4393 9.43934C21.158 9.72064 21 10.1022 21 10.5V27C21.0001 27.2644 21.0701 27.5241 21.2028 27.7527C21.3356 27.9814 21.5264 28.1709 21.756 28.302L32.256 34.302C32.6006 34.4882 33.0043 34.5323 33.381 34.4248C33.7576 34.3172 34.0772 34.0667 34.2715 33.7266C34.4659 33.3865 34.5195 32.9839 34.4209 32.6049C34.3223 32.2258 34.0794 31.9003 33.744 31.698L24 26.13V10.5Z",
    fill: "#181933"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 48C30.3652 48 36.4697 45.4714 40.9706 40.9706C45.4714 36.4697 48 30.3652 48 24C48 17.6348 45.4714 11.5303 40.9706 7.02944C36.4697 2.52856 30.3652 0 24 0C17.6348 0 11.5303 2.52856 7.02944 7.02944C2.52856 11.5303 0 17.6348 0 24C0 30.3652 2.52856 36.4697 7.02944 40.9706C11.5303 45.4714 17.6348 48 24 48ZM45 24C45 29.5695 42.7875 34.911 38.8492 38.8492C34.911 42.7875 29.5695 45 24 45C18.4305 45 13.089 42.7875 9.15076 38.8492C5.21249 34.911 3 29.5695 3 24C3 18.4305 5.21249 13.089 9.15076 9.15076C13.089 5.21249 18.4305 3 24 3C29.5695 3 34.911 5.21249 38.8492 9.15076C42.7875 13.089 45 18.4305 45 24Z",
    fill: "#181933"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_584_928"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.9c03bfe4f1fdb41c526471febf3e4fc8.svg";
export { ForwardRef as ReactComponent };